// Runtime loader for the logo/header images used by the CV templates.
// Browser-only (uses fetch + Image): the Word export is generated client-side,
// same as the PDF. Returns the bytes plus the natural pixel size so callers can
// scale to a target width/height while preserving aspect ratio.

function naturalSize( objectUrl ) {
    return new Promise( ( resolve, reject ) => {
        const img = new Image();
        img.onload = () => resolve( { width: img.naturalWidth, height: img.naturalHeight } );
        img.onerror = reject;
        img.src = objectUrl;
    } );
}

// Returns { data: ArrayBuffer, width, height } or null if the asset can't be loaded.
export async function loadImage( src ) {
    try {
        const response = await fetch( src );
        if ( !response.ok ) {
            return null;
        }
        const data = await response.arrayBuffer();
        const objectUrl = URL.createObjectURL( new Blob( [ data ] ) );
        try {
            const { width, height } = await naturalSize( objectUrl );
            return { data, width, height };
        } finally {
            URL.revokeObjectURL( objectUrl );
        }
    } catch ( error ) {
        return null;
    }
}

// Scale an intrinsic {width,height} so its width equals targetWidth (px).
export function scaleToWidth( natural, targetWidth ) {
    const ratio = natural.height / natural.width;
    return { width: Math.round( targetWidth ), height: Math.round( targetWidth * ratio ) };
}

// Scale an intrinsic {width,height} so its height equals targetHeight (px).
export function scaleToHeight( natural, targetHeight ) {
    const ratio = natural.width / natural.height;
    return { width: Math.round( targetHeight * ratio ), height: Math.round( targetHeight ) };
}

// Scale an intrinsic {width,height} to fit within maxW x maxH (px), preserving
// aspect ratio (mirrors CSS object-fit: contain).
export function scaleToFit( natural, maxWidth, maxHeight ) {
    const scale = Math.min( maxWidth / natural.width, maxHeight / natural.height );
    return { width: Math.round( natural.width * scale ), height: Math.round( natural.height * scale ) };
}
